import React from 'react'
import { shallow } from 'enzyme'
import { Pagination } from '../features/dashboard/Pagination'

describe('<Pagination />', () => {
  const noop = () => {}
  let props
  beforeEach(() => {
    props = {
      data: {
        loading: false,
        error: false,
        administratorsCount: 3
      },
      totalPages: 4,
      totalRecords: 40,
      currentPage: 1,
      changePage: noop,
      next: noop,
      prev: noop,
      first: noop,
      perPage: 10,
      changePerPage: noop
    }
  })
  describe('when it has been supplied with data', () => {
    it('should render without crashing', () => {
      expect(shallow(<Pagination {...props} />)).toBeTruthy()
    })
  })
  describe('when it is loading or there is an error', () => {
    beforeEach(() => {
      props = {
        ...props,
        data: {
          error: true,
          loading: true
        }
      }
    })
    it('should return null', () => {
      expect(Pagination(props)).toBeNull()
    })
  })
})
